import { render } from "./CleaningLocationComponent.vue?vue&type=template&id=63174c72"
import script from "./CleaningLocationComponent.vue?vue&type=script&lang=js"
export * from "./CleaningLocationComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__